module.exports = __webpack_public_path__ + "img/icon3.50cd73b5.png";